module Cfnc {
    "use strict";

    interface IAltSrc extends angular.IScope{
        altSrc: string;
    }

    class AltSrc implements ng.IDirective {
        static directiveId: string =  "altSrc";
        restrict: string = "A";
        scope: any = {
            altSrc: "@"
        };
        constructor() {
        }

        link = (scope: IAltSrc, element: angular.IAugmentedJQuery) => {
            element.hide();

            element.on("error", event => {
                event.target.setAttribute("src", scope.altSrc)
            });

            element.on("load", (event) => {
                $(event.target).show();
            });
        }
    }

    angular.module("app").directive(AltSrc.directiveId, [() => new AltSrc()]);
}
